import { useFastLane } from '../store/index';

export function useColorRushColor(index: number) {
    const colorRushEntry = useFastLane(f => f.getColorRushEntry(index));

    return colorRushEntry;
}

export function usePlayColorRush() {
    const index = useFastLane(f => f.playingIndex);
    const sceneCount = useFastLane(f => f.getSceneCount());

    return index % sceneCount < 2;
}

export function useColorRushInvert(index: number) {
    const color = useColorRushColor(index);
    const playing = usePlayColorRush();

    // check if the color is bright if so return true
    if (!color) {
        return false;
    }

    return isLightOrDark(color.color) === 'light' && playing;
}

function isLightOrDark(hexColor: string): 'light' | 'dark' {
    // Remove # if present
    hexColor = hexColor.replace('#', '');

    // Convert hex to RGB
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);

    // Calculate luminance (perceived brightness)
    // Using the formula: 0.299*R + 0.587*G + 0.114*B
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return 'light' if luminance is greater than 0.5, otherwise 'dark'
    return luminance > 0.5 ? 'light' : 'dark';
}
